import { render, staticRenderFns } from "./UnbindResources.vue?vue&type=template&id=74d2aef1"
import script from "./UnbindResources.vue?vue&type=script&lang=js"
export * from "./UnbindResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports